module.exports = __webpack_public_path__ + "img/teacher-qrcode.5f96bf81.png";